// Plan du salon public : masquer la navbar fixe quand elle recouvre la grille des stands.

const NAVBAR_OVERLAP_PX = 80

export function initStandsLayoutNavbarHide() {
  const plan = document.getElementById("stands-grid")
  if (!plan) return

  const navbars = document.querySelectorAll(".navbar")
  if (navbars.length === 0) return

  const update = () => {
    const { top, bottom } = plan.getBoundingClientRect()
    const overlapsNav = top < NAVBAR_OVERLAP_PX && bottom > 0
    navbars.forEach((nav) => nav.classList.toggle("navbar--hidden-over-plan", overlapsNav))
  }

  let ticking = false
  const onScrollOrResize = () => {
    if (ticking) return
    ticking = true
    requestAnimationFrame(() => {
      update()
      ticking = false
    })
  }

  document.addEventListener("scroll", onScrollOrResize, { passive: true })
  window.addEventListener("resize", onScrollOrResize, { passive: true })
  update()

  const teardown = () => {
    document.removeEventListener("scroll", onScrollOrResize)
    window.removeEventListener("resize", onScrollOrResize)
    navbars.forEach((nav) => nav.classList.remove("navbar--hidden-over-plan"))
  }

  document.addEventListener("turbolinks:before-cache", teardown, { once: true })
}
